import { GetState, SetState } from 'zustand';
import { SettingsStore } from '../../SettingsStore';

export function switchEnhancedReportSearch(set: SetState<SettingsStore>, get: GetState<SettingsStore>): void {
   const current: boolean = get().enhancedReportSearch;

   set({ enhancedReportSearch: !current });
}
